/**
 * Helper copy under the Focus vs. explore slider (levels 1–5).
 * Left = Focus-heavy, middle = balanced, right = Explore-heavy.
 */
export function explorationLevelHelperText(level) {
  if (level <= 2) return "Prioritizing closely matched professors";
  if (level === 3) return "A mix of relevant and varied recommendations";
  return "Showing a wider range of research areas";
}

/** Percent along track for teal fill (min–max inclusive). */
export function explorationSliderFillPercent(level, min = 1, max = 5) {
  if (max <= min) return 0;
  return ((level - min) / (max - min)) * 100;
}

/** Tailwind class names: emphasize label near current position. */
export function explorationSliderLabelClass(level, side) {
  if (side === "focus") {
    if (level <= 2) return "text-gray-800";
    if (level >= 4) return "text-gray-400";
    return "text-gray-500";
  }
  if (level >= 4) return "text-gray-800";
  if (level <= 2) return "text-gray-400";
  return "text-gray-500";
}
